import { TaxesFormFragment } from 'generated/resources/graphql'
import { v4 as uuid } from 'uuid'

import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

type ExpensesTax = NonNullable<NonNullable<TaxesFormFragment['expense']>['taxes'][number]>

export const getTaxesDefaultValues = (data?: TaxesFormFragment | null) => {
  const formatTaxes = (taxes: ExpensesTax[]) =>
    taxes.map(({ baseAmount, percentage, amount }) => {
      const formattedBaseAmount =
        baseAmount !== null && baseAmount !== undefined ? fromCents(baseAmount) : null
      const formattedAmount = amount !== null && amount !== undefined ? fromCents(amount) : null
      const formattedPercentage =
        percentage !== null && percentage !== undefined
          ? Number.parseFloat((percentage * 100).toFixed(2))
          : null
      return {
        id: uuid(),
        base_amount: formattedBaseAmount,
        percentage: formattedPercentage,
        amount: formattedAmount,
      }
    }) ?? []

  const defaultTaxes = (data?.expense?.taxes && formatTaxes(data.expense.taxes)) ?? []

  return {
    taxes: defaultTaxes,
  }
}
